import { Eye, EyeOff } from "lucide-react";
import type { ReactNode } from "react";
import { useState } from "react";
import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../primitives/form";
import { Input } from "../primitives/input";

interface ColocaPasswordFieldProps {
  name: string;
  label?: ReactNode;
  description?: ReactNode;
  placeholder?: string;
  autoComplete?: "current-password" | "new-password";
  showLabel?: string;
  hideLabel?: string;
}

export function ColocaPasswordField({
  name,
  label,
  description,
  placeholder,
  autoComplete = "new-password",
  showLabel = "Show password",
  hideLabel = "Hide password",
}: ColocaPasswordFieldProps) {
  const { control } = useFormContext();
  const [visible, setVisible] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <div className="relative">
              <Input
                {...field}
                type={visible ? "text" : "password"}
                placeholder={placeholder}
                autoComplete={autoComplete}
                className="pr-10"
              />
              <button
                type="button"
                onClick={() => setVisible((v) => !v)}
                tabIndex={-1}
                aria-label={visible ? hideLabel : showLabel}
                className="absolute inset-y-0 right-0 grid w-10 place-items-center text-muted-foreground hover:text-foreground"
              >
                {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
